























// Copyright © 2022 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import { DashmixAlertProps } from './Alert.contracts'
import { dashmixAlertProps, useDashmixAlert } from './Alert.hooks'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const DashmixAlert = defineComponent({
  name: 'DashmixAlert',
  props: dashmixAlertProps,

  setup: (props: DashmixAlertProps, ctx: SetupContext) => {
    return useDashmixAlert(props, ctx)
  }
})

export default DashmixAlert
